import { OperationTypeEnum } from "@gtpl/shared-models/common-models";

export class InventoryRequest{
    unitId:number;
    operation:OperationTypeEnum;
    constructor(unitId:number,operation:OperationTypeEnum){
        this.unitId = unitId;
        this.operation = operation;
    }
}